export const PLAN_TYPES = {
  BASIC: 'pln_F738DBB1929E59C7',
  STANDARD: 'pln_D6DF744B6432206D',
  PREMIUM: 'nani'
};

export const TrackingCodes = {
  Dependent: 'dependent'
};

export const TransactionStatusTypes = {
  Open: 'open',
  Concluded: 'concluded'
};

export const TransactionEventTypes = {
  AwaitingPayment: 'awaiting_payment'
};

export const TransctionEventBlockInfo = {
  [TransactionEventTypes.AwaitingPayment]: {
    description: 'Aguardando pagamento',
    iconCode: 'far fa-clock',
    color: '#e49300',
    title: 'Pedido Efetuado'
  }
};

export const NotificationTypes = {
  // Você vendeu um produto
  ProdutSold: 1 << 0,
  // Fizeram uma pergunta no seu anúncio
  AdQuestion: 1 << 2,
  // Seu anúncio foi finalizado
  AdEnded: 1 << 3,
  // Você comprou um produto
  PurchasedProduct: 1 << 4,
  // Você usou a auto-oferta
  SelfOffer: 1 << 5,
  // Seu anúncio está quase finalizado
  AdIsAboutToEnd: 1 << 6,
  // Escreveram para você pelo sistema de mensgens
  newMessages: 1 << 7,
  // Ofertas e promoções da Kacareco
  Promotions: 1 << 8
};
